import { Images } from 'src/assets'

const Portfolio = [
  {
    id: 1,
    name: 'Salary and Attendance Portal',
    description: 'Intuitive Web & Mobile App for efficiently managing employee attendance and salaries',
    technologies: ['React', 'React Native', 'Node', 'MongoDB'],
    gradient: { from: 'indigo', to: 'cyan' },
    image: Images.PortfolioImages.salaryApp,
    link: 'https://play.google.com/store/apps/details?id=com.salarymobileapp',
    detailedInfo: [
      'Custom Time & Location bounded Punch In/Punch Out from App',
      'Designed Custom Calender to show monthly Attendance & Rports in App',
      'Simplified yet accurate calculations for Payroll generation through Portal',
    ],
  },
  {
    id: 2,
    name: 'Sport Event App',
    description: 'A mobile app to efficiently organize, participate and host local sports events',
    technologies: ['React Native', 'Node', 'Appcenter'],
    gradient: { from: 'teal', to: 'lime', deg: 105 },
    image: Images.PortfolioImages.sportApp,
    link: 'https://play.google.com/store/apps/details?id=com.sportsweekapp',
    detailedInfo: [
      '3 Deliverables : Mobile App, Admin Panel, Backend',
      'Real-time score update, Refer & Earn, Virtual Selfie Point & many more ',
      'Customized Push Notification for Event Updates',
    ],
  },
  {
    id: 3,
    name: 'Cleanliness Mobile App & Portal',
    description: 'Streamlining garbage management in cities through a mobile app and web portal solution',
    technologies: ['React JS', 'TypeScript', 'Firebase', 'Machine Learning'],
    gradient: { from: 'red', to: 'grape' },
    image: Images.PortfolioImages.cleanLinessApp,
    link: 'https://play.google.com/store/apps/details?id=com.cleanuser.ssip',
    detailedInfo: [
      'Creating Tensorflow based Machine Learning model to validate inputs',
      'CI/CD Pipelines Setup to Deploy Web & App on push',
      'Integrate multiple Firebase Services like Storage, Analytics, Authentication etc',
    ],
  },
]

export { Portfolio }
